/* RESPONSIBLE TEAM: team-proactive-support */
/* === ⚠️ THIS FILE CURRENTLY USES DEPRECATED PATTERNS ⚠️ === */
/* === 🔗 For more information visit https://go.inter.com/ember-best-practices 🔗 */
/* === 🚀 Please consider refactoring & removing some of the comments below when working on this file 🚀 */
/* eslint-disable @intercom/intercom/no-bare-strings */
import { buildValidations, validator } from 'ember-cp-validations';

export default buildValidations({
  jsonBlocks: {
    description: 'Keyword response',
    validators: [
      validator('presence', {
        presence: true,
        message: 'The response should not be empty',
      }),
      validator('title-and-body-blocks-not-empty', {
        message: 'The response should not be empty',
      }),
    ],
  },
});
